import { Head } from '@inertiajs/react';
import withSourceColors from '@/hooks/withSourceColors.jsx';
import ApplicationWidget from '@/components/v1/widgets/ApplicationWidget.jsx';

const ExternalRegisterWidget = ({ presets, source, referer }) => {
    return (
        <>
            <Head title={`Financieringsaanvraag`} />

            <ApplicationWidget className={'max-w-screen-sm'} presets={presets} source={source} referer={referer} />
        </>
    );
};

export default withSourceColors(ExternalRegisterWidget);
